export default __webpack_public_path__ + "static/media/navbar-invoices-orange.aaae9e30.svg";